import { Box, CardContent, Stack, Typography } from "@mui/material";
import { CardOutline } from "components/Card";
import { REQUIREMENT } from "helpers/constants";
import { FC } from "react";
import { Requirement } from "types/requirement";
import { getAllowedTime } from "utils/Datetime";

type RequirementCriteriaItemProps = {
  label: string;
  value: number | string | null | undefined;
};

const RequirementCriteriaItem: FC<RequirementCriteriaItemProps> = ({
  label,
  value,
}) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography variant="body2">{label}</Typography>
      <Typography variant="body2">{value ?? "N/A"}</Typography>
    </Stack>
  );
};

type RequirementCriteriaProps = {
  requirement: Requirement;
  type: string;
};

export const RequirementCriteria: FC<RequirementCriteriaProps> = ({
  requirement,
  type,
}) => {
  return (
    <CardOutline sx={{ height: "100%" }}>
      <CardContent>
        <Box mb={2}>
          <Typography gutterBottom component="div" fontWeight={600}>
            Requirement Criteria
          </Typography>
        </Box>
        <Stack spacing={1}>
          {type === REQUIREMENT.REQUIREMENT_EPA && (
            <>
              <RequirementCriteriaItem
                label="Minimum Small Animal Count"
                value={
                  requirement?.min_small_animals_count &&
                  requirement?.min_small_animals_count > 0
                    ? requirement?.min_small_animals_count
                    : "N/A"
                }
              />

              <RequirementCriteriaItem
                label="Minimum Large Animal Count"
                value={
                  requirement?.min_large_animals_count &&
                  requirement?.min_large_animals_count > 0
                    ? requirement?.min_large_animals_count
                    : "N/A"
                }
              />
            </>
          )}

          {type === REQUIREMENT.REQUIREMENT_COMPETENCY && (
            <>
              <RequirementCriteriaItem
                label="Requirement Type"
                value={requirement?.requirement_type}
              />

              <RequirementCriteriaItem
                label="Animal Size"
                value={requirement?.animal_size}
              />

              <RequirementCriteriaItem
                label="Specific Species"
                value={requirement?.species ? requirement.species.name : null}
              />
            </>
          )}

          <RequirementCriteriaItem
            label="Minimum Attempts"
            value={
              requirement?.min_performance && requirement?.min_performance > 0
                ? requirement?.min_performance
                : "N/A"
            }
          />
          <RequirementCriteriaItem
            label="Target Score On Rubric"
            value={
              requirement?.min_score && requirement?.min_score > 0
                ? requirement?.min_score
                : "N/A"
            }
          />
          <RequirementCriteriaItem
            label="Allowed Task Time"
            value={
              requirement?.task_time
                ? getAllowedTime(requirement?.task_time)
                : ""
            }
          />
        </Stack>
      </CardContent>
    </CardOutline>
  );
};
